export default __webpack_public_path__ + "6a06a70222246945ee4bc2036614bca6.png";